<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar', 'Retencao')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormRetencao.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Nova Faixa de Retenção
      </v-btn>
      <DialogFormRetencao @created="create($event)" ref="dialogFormRetencao" />
      <v-form ref="formBusca">
        <v-row dense>
          <v-col cols="12" sm="12" md="5">
            <SelectEmpresa
              :multiple="true"
              @onChanged="filtro.empresas = $event"
              @onEmpresas="empresas = $event"
              return-object
            />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-select label="Papel" v-model="filtro.papel" :items="['Vendedor', 'Supervisor']">
              <template v-slot:selection="{ item }">
                <v-chip>
                  <span>{{ item }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="d-flex align-center justify-center">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Retencao from "@/services/retencao";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FiltroRetencao",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogFormRetencao: () => import("./DialogFormRetencao.vue")
  },

  data() {
    return {
      serviceRetencao: new Retencao(),
      filtro: {
        empresas: []
      },
      empresas: []
    };
  },

  computed: {
    ...mapGetters("retencao", ["getRetencao"])
  },

  methods: {
    ...mapActions({
      actionRetencao: "retencao/actionRetencao"
    }),

    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          const dados = await this.serviceRetencao.getByEmpresaPapel(
            this.filtro,
            this.empresas
          );

          this.actionRetencao(dados);
          if (dados.length === 0) {
            this.$toast.warning("Nada foi encontrado");
          }
        } catch (error) {
          this.$toast.error(error);
        }
      }
    },

    create(retencao) {
      if (this.getRetencao === null) {
        this.actionRetencao([
          {
            id: retencao.id,
            empresa: retencao.empresa,
            dataCriacao: retencao.dataCriacao,
            apelido: retencao.apelido,
            faixaRetencao1: retencao.faixaRetencao1,
            faixaRetencao2: retencao.faixaRetencao2,
            papel: retencao.papel
          }
        ]);
      } else {
        this.actionRetencao(
          this.getRetencao.concat(
            ...[
              {
                id: retencao.id,
                empresa: retencao.empresa,
                dataCriacao: retencao.dataCriacao,
                apelido: retencao.apelido,
                faixaRetencao1: retencao.faixaRetencao1,
                faixaRetencao2: retencao.faixaRetencao2,
                papel: retencao.papel
              }
            ]
          )
        );
      }
    }
  },

  async mounted() {
    try {
      if (this.getRetencao.length === 0) {
        const response = await this.serviceRetencao.getAll();
        this.actionRetencao(response);
      }
    } catch (error) {
      this.$toast.error(`Erro ao buscar os dados`);
    }
  }
};
</script>

<style></style>
